module.exports = import("https://esm.sh/react-canvas-confetti/dist/presets/fireworks");;